import React from 'react';
import {
  OrderStatusCssClasses,
  OrderStatusTitles,
} from './../../OrdersUIHelpers';

export function StatusColumnFormatter(cellContent, row) {
  const getLabelCssClasses = () => {
    return `label label-lg label-${
      OrderStatusCssClasses[row.status + 1]
    } label-inline`;
  };
  return (
    <span className={getLabelCssClasses()}>
      {OrderStatusTitles[row.status + 1]}
    </span>
  );
}
